import moment from 'moment';

export const filterCustomers = (customers, search, statusFilter, dateRange) => {
  if (!customers) return [];
  
  return customers.filter(customer => {
    const searchMatch = search === "" || 
      `${customer.firstName} ${customer.lastName}`.toLowerCase().includes(search.toLowerCase()) ||
      customer.email.toLowerCase().includes(search.toLowerCase()) ||
      (customer.phone && customer.phone.includes(search));
    
    const statusMatch = statusFilter === "All" || customer.status === statusFilter;
    
    let dateMatch = true;
    if (dateRange && dateRange.length === 2) {
      const customerDate = moment(customer.createdAt);
      dateMatch = customerDate.isSameOrAfter(dateRange[0], 'day') && 
                  customerDate.isSameOrBefore(dateRange[1], 'day');
    }
    
    return searchMatch && statusMatch && dateMatch;
  });
};

// utils/exportToCSV.js
export const exportToCSV = (data, filename) => {
  // Convert data to CSV string
  const headers = Object.keys(data[0]).join(',');
  const rows = data.map(item => 
    Object.values(item)
      .map(val => `"${String(val).replace(/"/g, '""')}"`)
      .join(',')
  ).join('\n');
  
  const csvContent = `${headers}\n${rows}`;
  
  // Create download link
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


// utils/exportToCSV.js
export const exportReportsToCSV = (data, filename) => {
  // Convert data to CSV string
  const csvContent = convertToCSV(data);
  
  // Create download link
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const convertToCSV = (data) => {
  if (!data || data.length === 0) return '';
  
  // Extract headers
  const headers = Object.keys(data[0]);
  
  // Create CSV rows
  const rows = data.map(item => 
    headers.map(header => 
      `"${item[header] !== undefined ? String(item[header]).replace(/"/g, '""') : ''}"`
    ).join(',')
  );
  
  return [headers.join(','), ...rows].join('\n');
};